// src/components/Filters/SupplementFormFilter.js
import React from 'react';
import { supplementForms } from '../../data/filterOptions';
import './FilterStyles.css'; // We'll create a common style file

const SupplementFormFilter = ({ selectedForms, onChange }) => {
  const handleChange = (form) => {
    const newSelectedForms = { ...selectedForms };
    newSelectedForms[form] = !newSelectedForms[form];
    onChange(newSelectedForms);
  };

  return (
    <div className="filter-section">
      <h3>Supplement Type</h3>
      <div className="filter-options-grid checkbox-grid">
        {supplementForms.map(form => (
          <label key={form} className="filter-option-label">
            <input
              type="checkbox"
              checked={selectedForms[form] || false}
              onChange={() => handleChange(form)}
            />
            {form}
          </label>
        ))}
      </div>
    </div>
  );
};

export default SupplementFormFilter;
